<template>
  <div class="flex-box vertical">
    <a-form-model
      class="flex-grow"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :layout="layout"
      :label-align="labelAlign"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="区块名称" prop="name">
        <a-input
          v-model="form.name"
          placeholder="输入区块名称（最多10字）"
          :max-length="10"
          allow-clear
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属区域" prop="mem_tablet_region_id">
        <a-select
          v-model="form.mem_tablet_region_id"
          :options="regionList"
          placeholder="选择所属区域"
          allow-clear
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设置区块" prop="type">
        <a-radio-group
          v-model="form.type"
          :options="typeOptions"
          placeholder="选择区块规则"
          allow-clear
        >
        </a-radio-group>
        <div>
          <a-space>
            <a-form-model-item label="行">
              <a-input-number
                v-model="form.rows"
                placeholder="输入行"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="列">
              <a-input-number
                v-model="form.cols"
                placeholder="输入列"
              ></a-input-number>
            </a-form-model-item>
            <a-button
              type="primary"
              :disabled="!(form.rows && form.cols)"
              @click="createBlockArea(form.rows, form.cols)"
            >
              生成
            </a-button>
          </a-space>
        </div>
        <BlockArea :list="this.nicheList" :selected="form.type == 2" />
      </a-form-model-item>
      <a-form-model-item label="编号方式" prop="num_type">
        <a-radio-group
          v-model="form.num_type"
          :options="numberMethodOptions"
          placeholder="选择编号方式"
          allow-clear
        >
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="供奉方式" prop="method">
        <a-radio-group
          v-model="form.method"
          :options="offeringMethodOptions"
          placeholder="选择供奉方式"
          allow-clear
        >
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="龛位价格" prop="price">
        <div class="flex-box align-center">
          <a-input-number
            v-model="form.price"
            placeholder="输入龛位价格"
            :min="1"
            :precision="2"
            :formatter="(value) => value / 100"
            :parser="(value) => value * 100"
          ></a-input-number>
          <span class="unit">元</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="设置图标" prop="mem_tablet_icon_id">
        <IconList v-model="form.mem_tablet_icon_id" :list="iconList" />
      </a-form-model-item>
      <a-form-model-item label="是否对外开放" prop="is_open">
        <a-switch v-model="form.is_open"></a-switch>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { clone } from "../../../common/js/tool";
import { createBaseBlock } from "../../../common/tablet/block";
import {
  numberMethodOptions,
  offeringMethodOptions,
  typeOptions,
} from "../../../common/tablet/type";
import BlockArea from "./BlockArea.vue";
import IconList from "./IconList.vue";

export default {
  name: "AreaForm",
  components: {
    BlockArea,
    IconList,
  },
  props: {
    initial: Object,
    labelCol: Object,
    wrapperCol: Object,
    labelAlign: {
      type: String,
      default: "left",
    },
    layout: {
      type: String,
      default: "vertical",
    },
    showIcon: Boolean,
  },
  data() {
    return {
      form: {},
      rules: {
        name: [{ required: true, message: "请输入区块名称", trigger: "blur" }],
        mem_tablet_region_id: [
          { required: true, message: "请选择所属区域", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择区块规则", trigger: "change" },
        ],
        num_type: [
          { required: true, message: "请选择编号方式", trigger: "change" },
        ],
        method: [
          { required: true, message: "请选择供奉方式", trigger: "change" },
        ],
        price: [{ required: true, message: "请输入龛位价格", trigger: "blur" }],
        mem_tablet_icon_id: [
          { required: true, message: "请选择图标", trigger: "change" },
        ],
        is_open: [
          {
            required: true,
            message: "请选择是否开放",
            trigger: "change",
            type: "boolean",
          },
        ],
      },
      regionList: [],
      iconList: [],
      showTip: false,
      typeOptions,
      numberMethodOptions,
      offeringMethodOptions,

      nicheList: [],
      sourceNicheList: [], // 龛位列表（原始数据）
      maxRow: 0,
      maxCols: 0,
    };
  },
  computed: {
    isEdit() {
      return !!this.form?.id;
    },
  },
  watch: {
    initial() {
      this.init();
    },
    "form.num_type": function () {
      this.changeNumType();
    },
  },
  async created() {
    await this.getIcon();
    await this.getRegion();
    this.init();
    this.getBlockList();
  },
  methods: {
    // 获取编号
    setNum(item, maxRow, maxCols, num_type) {
      let num;
      const rowPadding = maxRow.toString().length;
      const colPadding = maxCols.toString().length;
      const totalPadding = (maxRow * maxCols).toString().length;
      switch (num_type) {
        case 1:
          // 按照行与列生成编号
          num = `${item.row.toString().padStart(rowPadding, "0")}${item.cols
            .toString()
            .padStart(colPadding, "0")}`;
          break;
        case 2:
          // 按照顺序供奉
          num = ((item.row - 1) * maxCols + item.cols)
            .toString()
            .padStart(totalPadding, "0");
          break;
      }
      item.num = num;
    },
    // 编号生成方式更换
    changeNumType() {
      this.nicheList.forEach((line) => {
        line?.forEach((item) => {
          this.setNum(item, this.maxRow, this.maxCols, this.form.num_type);
        });
      });
    },
    // 生成佛龛
    createBlockArea(r, c, initial) {
      this.maxRow = r;
      this.maxCols = c;
      const blockList = createBaseBlock(r, c);
      const nicheList = blockList.map((line) => {
        return line.map(({ row, cols }) => {
          let item = {
            row,
            cols,
            mem_tablet_block_id: this.form?.id, // 区块id
            selected: !initial,
          };
          const niche = this.nicheList.find(
            (item) => item.row == row && item.cols == cols
          );
          if (niche) {
            item = niche;
            initial && this.$set(item, "selected", true);
          }
          this.setNum(item, r, c, this.form.num_type); // 设置编号
          return item;
        });
      });
      this.nicheList = nicheList;
    },
    // 获取最大行列数
    getRowsAndCols(list = []) {
      const rows = list.map((item) => item.row);
      const cols = list.map((item) => item.cols);
      const maxRow = Math.max(...rows);
      const maxCols = Math.max(...cols);
      this.maxRow = maxRow;
      this.maxCols = maxCols;
      return { maxRow, maxCols };
    },
    // 获取区块的佛龛列表
    getBlockList() {
      const tabletBlockItem = this.form.tabletBlockItem || [];
      this.nicheList = clone(tabletBlockItem); // 佛龛列表
      this.sourceNicheList = clone(tabletBlockItem); // 保存原始数据
      const { maxRow, maxCols } = this.getRowsAndCols(tabletBlockItem);
      this.createBlockArea(maxRow, maxCols, true);
    },
    getRegion() {
      return this.$axios({
        url: "/admin/memorial-tablet-region",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.regionList = res.data.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    init() {
      let initial = this.initial;
      let form = null;
      if (initial) {
        form = clone(initial);
        form.is_open = form.is_open == 1;
      } else {
        form = {
          mem_tablet_icon_id: this.iconList[0]?.id, // 默认选择第一个图标
          is_open: false,
        };
      }
      this.$set(this, "form", form);
    },
    getIcon() {
      return this.$axios({
        url: "/admin/memorial-tablet-icon",
        method: "GET",
        params: {
          sort: "-id",
          pageSize: 9999,
        },
      }).then((res) => {
        this.iconList = res.data;
      });
    },
    dealNicheList(source, list) {
      const params = {
        add: [],
        update: [],
        delete: [],
      };
      list.forEach((line) => {
        line.forEach((item) => {
          if (item.id) {
            // 原本存在
            const index = source.findIndex((n) => n.id === item.id);
            if (index > -1) {
              source.splice(index, 1);
              if (item.selected) {
                // 选中则更新
                params.update.push(item);
              } else {
                params.delete.push(item);
              }
            } else {
              params.delete.push(item);
            }
          } else {
            // 原本不存在，选中则新增
            item.selected && params.add.push(item);
          }
        });
      });
      source.forEach((item) => {
        params.delete.push(item);
      });
      params.delete = params.delete.map((item) => item.id).join(",");
      return params;
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((flag) => {
          if (flag) {
            for (let i = 0; i < this.nicheList.length; i++) {
              const line = this.nicheList[i];
              const flag = line.some((item) => item.selected);
              if (!flag) {
                this.$message.warning("请至少选择一个佛龛");
                reject();
                return;
              }
            }
            const nicheParams = this.dealNicheList(
              clone(this.sourceNicheList),
              this.nicheList
            );
            let form = clone(this.form);
            form.is_open = form.is_open ? 1 : 2;
            Object.assign(form, nicheParams);
            resolve(form);
          } else {
            reject();
          }
        });
      });
    },
    confirm(formData) {
      this.form = formData;
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-radio-group {
  min-height: 32px;
  line-height: 32px;
}
.input-item {
  display: inline-block;
  margin-bottom: 0;
  padding-bottom: 0;
}
.special-item {
  display: inline-block;
  width: 100%;
  padding: 0;
}
.mb-0 {
  margin-bottom: 0;
}
.ant-input-number {
  width: 240px;
}
.common-title {
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: 600;
}
.select-item {
  display: inline-block;
  ::v-deep &.limit-item {
    margin-left: 32px;
    .ant-form-item-label {
      line-height: 32px;
    }
  }
  .ant-select {
    width: 240px;
  }
}

.unit {
  margin-left: 12px;
}
</style>
